import { DailyPoint } from './types';

// Categorical hues in fixed order, never cycled. Validated against this page's chart surfaces
// (#ffffff light, #212327 dark): every gate passes, worst adjacent CVD ΔE 9.1 light / 8.4 dark.
// Light contrast sits under 3:1 for some slots, which is why the chart always offers a table view.
//
// AIDEV-NOTE: do not reorder or extend this list to fit a new use case. A 7th series folds into
// "Other" (see foldUseCases) — a generated hue would not be validated.
export const SERIES_LIGHT = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300'];
export const SERIES_DARK = ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300'];

export const OTHER = 'Other';
const MAX_SERIES = SERIES_LIGHT.length;

export interface ChartRow {
  [useCase: string]: string | number;
  date: string;
}

export const foldUseCases = (daily: DailyPoint[]) => {
  const totals = new Map<string, number>();
  (daily ?? []).forEach(({ tokens, use_case: useCase }) => {
    totals.set(useCase, (totals.get(useCase) ?? 0) + tokens);
  });

  const ranked = [...totals.entries()].sort((a, b) => b[1] - a[1]).map(([name]) => name);
  const kept = ranked.length > MAX_SERIES ? ranked.slice(0, MAX_SERIES - 1) : ranked;
  const series = ranked.length > MAX_SERIES ? [...kept, OTHER] : kept;

  const byDate = new Map<string, ChartRow>();
  daily.forEach(({ date, tokens, use_case: useCase }) => {
    const row = byDate.get(date) ?? { date };
    const key = kept.includes(useCase) ? useCase : OTHER;
    row[key] = ((row[key] as number) ?? 0) + tokens;
    byDate.set(date, row);
  });

  const rows = [...byDate.values()].sort((a, b) => a.date.localeCompare(b.date));
  const filled = rows.map(row => series.reduce((acc, name) => (
    { ...acc, [name]: (row[name] as number) ?? 0 }
  ), row));

  return { rows: filled, series };
};

export const formatTokens = (n: number) => {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${Math.round(n / 1_000)}K`;
  return String(n);
};
